import React from 'react';
import { Segment, TabPanel, Tabs } from 'tea-component';
import CommonBarAndLine, {
  CommonBarAndLineType,
} from '../../components/CommonBarAndLine';
import TableCard from '../TableCard';
import { tabMap, tabOptions } from '../../constants';
import Tips from '@/pages/opinion/components/Snippets/Tips';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import './index.scss';

interface SubMenuCardType extends CommonBarAndLineType {
  records: Array<any>; // 表格数据
  setDataType: (value: string) => void;
  dataType: string;
  type: string;
  splitText: string;
  loading: boolean;
  apiError: boolean;
  noData: boolean;
  noShare: boolean;
  dataMap: {};
}

export default function SubMenuCard(chartProps: SubMenuCardType) {
  const {
    chartType,
    dataMap = {},
    setDataType,
    dataType,
    loading,
    apiError,
    noShare,
    type,
    splitText,
  } = chartProps;

  const { formatMessage, formatOptionsMessage } = useLanguage();

  return (
    <div className="sub-menu-chart-card-wrapper">
      <Segment
        className="segment-box"
        value={dataType}
        onChange={setDataType}
        options={formatOptionsMessage(tabOptions)}
      />

      {/* 使用样式隐藏了tab */}
      <Tabs
        activeId={dataType}
        tabs={tabOptions.map((item) => ({ id: item.value, label: item.text }))}
      >
        {tabOptions.map((item) => {
          const key = item.value;
          const { x, y, tableRecord } = dataMap?.[key] || {
            x: [],
            y: [],
            tableRecord: [],
          };
          const noData = y.length === 0;
          return (
            <TabPanel id={key} key={key}>
              <Tips
                loading={loading}
                apiError={apiError}
                noData={noData}
                className={loading || apiError || noData ? 'no-data-tips' : ''}
              >
                {chartType === 'table' ? (
                  <TableCard
                    noShare={noShare}
                    className={'sub-menu-table-card'}
                    theThirdColumnConfig={{
                      key: 'value',
                      header: formatMessage({ id: tabMap[dataType] }),
                    }}
                    type={type}
                    splitText={splitText}
                    tableHeight={235}
                    tipsHeight={180}
                    records={tableRecord}
                  />
                ) : (
                  <CommonBarAndLine
                    {...chartProps}
                    xAxisData={x}
                    seriesDataArray={y}
                    height={273}
                  ></CommonBarAndLine>
                )}
              </Tips>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
}
